import React, { useState,useEffect } from 'react'
import CommonTablePage from '../../../components/common/common-table/common-table-page'
import { urlKey } from '../../../services/api/api-urls'
import ProductManagementColumnModel from './product-management-column-model'
import { getRandomKey, nsStr } from '../../../services/lib/utils/helpers'
import CommonDialog from '../../../components/common/others/common-dialog'
import AddOutsourceProductDialog from './add-outsource-product-dialog'
import ProductManagementDialog from '../product-management-dialog/product-management-dialog'
import { getCookie } from 'react-use-cookie'
import './product-management.css'
import { ApiRequest } from '../../../services/api/api'
import SweetAlertService from '../../../services/lib/utils/sweet-alert-service'
import { getUserId } from '../../../services/lib/utils/auth.utils'
import { useDocumentTitle } from '../../../services/title/useDocumentTitle'

const ProductManagementPage = (props: {customerId: any}): any => {
  const [triggerResetData, setTriggerResetData] = useState<any>(false)
  const [open, setOpen] = useState(false) // Dialog
  const [productDialogVisible, setProductDialogVisible] = useState(false)
  const [productDialogMode, setProductDialogMode] = useState<'add' | 'edit' | 'view'>('add')
  const [selectedProduct, setSelectedProduct] = useState<any>(null)

  const onDialogClose = (isModified: boolean) => {
    setOpen(false)
    if (isModified) {
      setTriggerResetData(getRandomKey())
    }
  }

  const handleProductDialogClose = (saved?: boolean) => {
    setProductDialogVisible(false)
    setSelectedProduct(null)
    if (saved) {
      setTriggerResetData(getRandomKey())
    }
  }

  const handleOpenProductDialog = (mode: 'add' | 'edit' | 'view', productData?: any) => {
    setProductDialogMode(mode)
    setSelectedProduct(productData || null)
    setProductDialogVisible(true)
  }
  useDocumentTitle();
  // useEffect(() => {
  //   document.title = "Product";
  //  }, [])
  const handleOpenPopup = (rowData:any) => {
  // setSelectedRowData(rowData);
  // setOpenPopup(true);
  console.log(rowData);
};
  return (
    <>
      <CommonTablePage
        urlInfoKey={ urlKey.Product }
        getAllUrl={'Product/GetAllProduct?withOutStock=true'}
        title="Products"
        triggerResetData={triggerResetData}
        onAddClick={() => handleOpenProductDialog('add')}
        actionButtons={[
          {
            icon: 'edit',
            tooltip: 'Edit',
            isFreeAction: false,
            onClick: (event: any, rowData: any) => {
              handleOpenProductDialog('edit', rowData)
            }
          },
          {
            icon: 'ghost', //Button attr of Ant design (danger, ghost)
            tooltip: 'Delete',
            isFreeAction: false,
            onClick: async (event: any, rowData: any) => {
              const resultInput = await SweetAlertService.deleteConfirm();
              if (resultInput.dismissed) return;
              const [name, reason] = Array.isArray(resultInput.value) ? resultInput.value : [];
                           
              ApiRequest({ url: `Product/DeleteProduct?id=${rowData.productId}&userId=${getUserId()}&userName=${name}&Notes=${reason}`, method: 'delete'})
              .then((res: any) => {
                SweetAlertService.successMessage()
                setTriggerResetData(getRandomKey())
              })
            }
          }
        ]}
        isNotDeletable={true}
        column={ ProductManagementColumnModel() }
        mappingRenderData={(data: any) => {
          const newData = data.map((row: any) => {
            // Determine if using different customer code
            const useDifferentCustCode = row.custProductCode && row.productCode && row.custProductCode !== row.productCode

            return {
              ...row,
              marginOfError: row.marginOfError?.toString(),
              useDifferentCustCode: useDifferentCustCode ? 1 : 0,
              productInfo: (
                row.productName +
                row.customer?.company +
                row.customer?.customerCode +
                row.baseProduct?.baseProductName +
                nsStr(
                  row.productName +
                  row.customer?.company +
                  row.customer?.customerCode +
                  row.baseProduct?.baseProductName
                )
              )
            }
          })
          if (props.customerId) {
            return newData.filter((row: any) => row.customerId === props.customerId)
          }
          return newData
        }}
        mappingUpdateData={ async (dataDetail: any, type: string) => {
          // 检查 Product Code 是否超过 22 个字符（仅对非外采产品）
          // manufactured = 1 或 logoType = 3 表示外采产品，跳过长度检查
          const isOutsourcedProduct = dataDetail.manufactured === 1

          if (!isOutsourcedProduct && dataDetail.productCode && dataDetail.productCode.length > 22) {
            const result = await SweetAlertService.warningConfirm(
              `Product Code exceeds 22 characters (${dataDetail.productCode.length} chars). Do you want to continue saving?`,
              'Warning'
            );
            if (result.dismissed) {
              return null; // 用户取消，中止保存
            }
          }

          // 判断是否使用不同的客户代码
          const codesAreDifferent = dataDetail.custProductCode && dataDetail.productCode && dataDetail.custProductCode !== dataDetail.productCode
          const useDifferentCustCode = codesAreDifferent ? 1 : 0

          return {
            ...dataDetail,
            plain: dataDetail.plain && parseInt(dataDetail.plain, 10),
            logoType: dataDetail.logoType && parseInt(dataDetail.logoType, 10),
            marginOfError: parseInt(dataDetail.marginOfError, 10) || 100,
            useDifferentCustCode: useDifferentCustCode,
            employeeId : getCookie('customerUserId')?0:parseInt(getCookie('id'))
          };
        } }
      />
      {/* Product Management Dialog */}
      <ProductManagementDialog
        visible={productDialogVisible}
        onClose={handleProductDialogClose}
        productData={selectedProduct}
        mode={productDialogMode}
      />
      {/* <CommonDialog
        title={'Add Outsourced Product'}
        open={open}
        onDialogClose={onDialogClose}
        dialogContent={<AddOutsourceProductDialog onDialogClose={onDialogClose}/>}
      /> */}
    </>
  )
}

export default ProductManagementPage
